import Vue from 'vue';
import VueResource from 'vue-resource';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaVisualizar(acompanhamento) {
  if (!((acompanhamento.atividadesIniciadas === undefined) || (acompanhamento.atividadesIniciadas === null))) {
    acompanhamento.atividadesIniciadas = acompanhamento.atividadesIniciadas ? "true" : "false";
  }

  if (!((acompanhamento.cronogramaCumprido === undefined) || (acompanhamento.cronogramaCumprido === null))) {
    acompanhamento.cronogramaCumprido = acompanhamento.cronogramaCumprido ? "true" : "false";
  }

  if (!((acompanhamento.planoOrcamentoCumprido === undefined) || (acompanhamento.planoOrcamentoCumprido === null))) {
    acompanhamento.planoOrcamentoCumprido = acompanhamento.planoOrcamentoCumprido ? "true" : "false";
  }

  if (!((acompanhamento.normasRespeitadas === undefined) || (acompanhamento.normasRespeitadas === null))) {
    acompanhamento.normasRespeitadas = acompanhamento.normasRespeitadas ? "true" : "false";
  }

  if (!((acompanhamento.intercorrencia === undefined) || (acompanhamento.intercorrencia === null))) {
    acompanhamento.intercorrencia = acompanhamento.intercorrencia ? "true" : "false";
  }

  return acompanhamento;
}

function normalizarParaSalvar(acompanhamento) {
  acompanhamento.atividadesIniciadas = acompanhamento.atividadesIniciadas === "true" ? true : false;
  acompanhamento.cronogramaCumprido = acompanhamento.cronogramaCumprido === "true" ? true : false;
  acompanhamento.planoOrcamentoCumprido = acompanhamento.planoOrcamentoCumprido === "true" ? true : false;
  acompanhamento.normasRespeitadas = acompanhamento.normasRespeitadas === "true" ? true : false;
  acompanhamento.intercorrencia = acompanhamento.intercorrencia === "true" ? true : false;
  
  return acompanhamento;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);
    return Vue.http.get('/api/acompanhamentoProjeto', { params: parametros });
  },
  alterar: (acompanhamento, arquivos, id) => {
    acompanhamento = normalizarParaSalvar(acompanhamento);
    acompanhamento.arquivos = arquivos;

    acompanhamento = converterObjetoFormData(acompanhamento);

    return Vue.http.put(`/api/acompanhamentoProjeto/${id}`, acompanhamento).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/acompanhamentoProjeto/${id}`)
      .then(response => normalizarParaVisualizar(response.body));
  },
  arquivos: id => {
    return Vue.http.get(`/api/acompanhamentoProjeto/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/acompanhamentoProjeto/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acompanhamento-projeto/servico.js